"use strict";
var appn;
(function (appn) {
    var views;
    (function (views) {
        var taskTemplates;
        (function (taskTemplates) {
            var wizard3;
            (function (wizard3) {
                let _newFieldCounter = 0;
                function init() {
                    addEvents();
                    initializeValues();
                }
                wizard3.init = init;
                function addEvents() {
                    $('form#appnForm').on('submit', function () {
                        $('input[name=fileName]').each((index, fileName) => {
                            const filesInput = appn.elementBuilder.getSimpleInputFor(undefined, `Wizard.Template.Task.Files[${index}].Name`, `Wizard_Template_Task_Files_${index}__Name`, appn.elementBuilder.HTMLInputType.Hidden, undefined, $(fileName).val());
                            $('form#appnForm').append(filesInput);
                        });
                        return true;
                    });
                    $('#attachfiles').on('click', function (e) {
                        e.preventDefault();
                        const idx = new Date().getTime();
                        $('#attachmentItems tbody').append(`<tr><td class="typeCell"><div><input type="hidden" name="Wizard.Template.Task.Files.Index" value="${idx}" /><input type="file" name="fileAttachments" id="fileAttachments${idx}" /><span class="field-validation-valid" data-valmsg-for="Wizard.Template.Task.Files[${idx}].Name" data-valmsg-replace="true"></span></div></td><td></td><td></td><td class="text-right">${appn.elementBuilder.buildBtnRemoveRow('delete_file_button')}</td></tr>`);
                    });
                    $(document).on('click', '.delete_file_button', function () {
                        $(this).parents('tr').remove();
                    });
                    $(document).on('click', '.delete_row', function () {
                        const table = $(this).closest('table');
                        $(this).closest('tr').remove();
                        fixRowNumbers(table);
                        appn.ui.handleParentResize(0, 0);
                    });
                    $('.addRow').on('click', function (e) {
                        e.preventDefault();
                        const id = $(this).attr('id');
                        const table = $(this).parent().find('table');
                        drawRowEditor(table.data('tabledataname'), id);
                        fixRowNumbers(table);
                        appn.select.init({
                            selector: `table[id="${id}"] tbody tr select`
                        });
                    });
                }
                function initializeValues() {
                    const tableColumnsInputs = $('input[id$="Value"]').filter('[parentname]');
                    const columnValuesList = [];
                    tableColumnsInputs.each((index, input) => {
                        const savedValue = [];
                        const isMulti = $(`input[dataname="${$(input).attr('dataname')}"][id$="Values"]`).length > 0 ? true : false;
                        if (isMulti) {
                            const columnValuesFlat = $(input).attr('value').split('|');
                            for (let row = 0; row < columnValuesFlat[0].split('%%').length; row++) {
                                const rowValues = [];
                                columnValuesFlat.forEach((columnValue, index, self) => {
                                    rowValues.push(columnValue.split('%%')[row]);
                                });
                                savedValue.push(rowValues.join('|'));
                            }
                        }
                        else
                            $(input).attr('value').split('%%').forEach((value) => {
                                savedValue.push(value);
                            });
                        const columnValues = {
                            tableName: $(input).attr('parentname'),
                            columnName: $(input).attr('dataname'),
                            multi: isMulti,
                            values: savedValue
                        };
                        columnValuesList.push(columnValues);
                    });
                    columnValuesList.sort((a, b) => {
                        if (a['tableName'] === b['tableName'])
                            return 0;
                        return (a['tableName'] < b['tableName']) ? -1 : 1;
                    });
                    const tableNames = columnValuesList.map(item => item.tableName).filter((value, index, self) => {
                        return self.indexOf(value) === index;
                    });
                    tableNames.forEach((tableName, index, self) => {
                        const columns = columnValuesList.filter((columnValue, index, self) => {
                            return columnValue.tableName === tableName;
                        });
                        const valueCountMax = columns.map(item => item.values.filter((value, index, self) => {
                            return value !== appn.emptyString;
                        }).length).reduce((a, b) => {
                            return Math.max(a, b);
                        });
                        if (valueCountMax === 0)
                            return;
                        const rows = columns[0].values.length;
                        for (let row = 0; row < rows; row++) {
                            $(`.addRow[id="${$(`table[data-tabledataname="${tableName}"]`).attr('id')}"]`).click();
                            columns.forEach((columnValue, index, self) => {
                                const value = columnValue.multi ? columnValue.values[row].split('|') : columnValue.values[row];
                                $(`table[data-tabledataname="${tableName}"] .form-control#${columnValue.tableName}__${columnValue.columnName}__row-${row + 1}`).val(value);
                            });
                        }
                    });
                }
                function drawRowEditor(tableName, tableId) {
                    const table = $(`table[id="${tableId}"]`);
                    const body = table.find('tbody');
                    const rows = body.find('tr').length;
                    const tableHeaders = table.find('thead tr th');
                    const initializePicker = [];
                    const columnDataNames = [];
                    tableHeaders.each((index, column) => {
                        const elementDataName = $(column).data('elementname');
                        if (elementDataName) {
                            columnDataNames.push(elementDataName);
                            const elementType = $(column).data('elementtype');
                            if (['Date', 'Time', 'DateTime'].indexOf(elementType) > -1)
                                initializePicker.push(elementType);
                        }
                    });
                    const row = getRow(rows + 1, tableName, columnDataNames);
                    body.append(row);
                    $('.datepicker').on('click', function () {
                        appn.ui.datePicker($(this));
                    });
                    $('.datetimepicker').on('click', function () {
                        appn.ui.dateTimePicker($(this));
                    });
                    $('.timepicker').on('click', function () {
                        appn.ui.timePicker($(this));
                    });
                    if (initializePicker.indexOf('Date') > -1)
                        appn.ui.datePicker($('.datepicker'));
                    if (initializePicker.indexOf('Time') > -1)
                        appn.ui.timePicker($('.timepicker'));
                    if (initializePicker.indexOf('DateTime') > -1)
                        appn.ui.dateTimePicker($('.datetimepicker'));
                }
                function fixRowNumbers(table) {
                    const rows = $(table.find('tbody tr'));
                    rows.find('.delete_row').removeAttr('disabled');
                    rows.each((index, row) => {
                        $(row).attr('id', index + 1);
                        $(row).find('td').first().text(index + 1);
                        if (rows.length <= 1)
                            $(row).find('.delete_row').attr('disabled', 'disabled');
                    });
                }
                function getRow(rowNumber, tableDataName, columnDataNames) {
                    const rowNumberCell = appn.elementBuilder.createElement('td', undefined, undefined, undefined, rowNumber.toString());
                    const deleteAction = appn.elementBuilder.buildBtnRemoveRow('delete_row');
                    const deleteCell = appn.elementBuilder.createElement('td');
                    deleteCell.appendChild(deleteAction.toHtmlElement());
                    const row = appn.elementBuilder.createElement('tr', undefined, rowNumber.toString());
                    row.appendChild(rowNumberCell);
                    columnDataNames.forEach((columnDataName) => {
                        row.appendChild(getCell(tableDataName, columnDataName));
                    });
                    row.appendChild(deleteCell);
                    return row;
                }
                function getCell(tableDataName, columnDataName) {
                    var _a, _b;
                    const column = $(`th[data-elementname="${columnDataName}"]`);
                    const required = column.data('required') ? column.data('required').toBooleanExact() : false;
                    const tableName = $(`input[type="hidden"][value="${tableDataName}"]`).attr('name');
                    const indexName = tableName.substring(0, tableName.lastIndexOf('['));
                    const newFieldNumber = _newFieldCounter;
                    const isMulti = column.data('elementtype') === 'SelectMulti' ? true : false;
                    const repeatFieldIndex = `${indexName}[new-${newFieldNumber}]`;
                    const inputName = `${repeatFieldIndex}.${isMulti ? 'Values' : 'Value'}`;
                    const inputId = getIdString(inputName);
                    const type = appn.elementBuilder.HTMLElementType[column.data('elementtype')];
                    const formInput = appn.elementBuilder.createElement('div', 'col-sm-12');
                    const cell = appn.elementBuilder.createElement('td');
                    cell.appendChild(appn.elementBuilder.getHiddenIndexerFor(indexName, newFieldNumber));
                    _newFieldCounter++;
                    cell.appendChild(appn.elementBuilder.getSimpleInputFor(undefined, `${repeatFieldIndex}.DataName`, getIdString(`${repeatFieldIndex}.DataName`), appn.elementBuilder.HTMLInputType.Hidden, undefined, columnDataName));
                    cell.appendChild(appn.elementBuilder.getSimpleInputFor(undefined, `${repeatFieldIndex}.Required`, getIdString(`${repeatFieldIndex}.Required`), appn.elementBuilder.HTMLInputType.Hidden, undefined, required ? 'True' : 'False'));
                    switch (type) {
                        case appn.elementBuilder.HTMLElementType.Date:
                        case appn.elementBuilder.HTMLElementType.DateTime:
                        case appn.elementBuilder.HTMLElementType.Time: {
                            formInput.appendChild(appn.elementBuilder.getDateTimePickerFor(type, 'form-control form-control-sm', inputName, inputId, undefined, undefined, required));
                            break;
                        }
                        case appn.elementBuilder.HTMLElementType.SelectOne:
                        case appn.elementBuilder.HTMLElementType.SelectMulti: {
                            const values = (_a = JSON.parse(column.find('input[id$="_dataValues"]').attr('value'))) !== null && _a !== void 0 ? _a : [];
                            const display = (_b = JSON.parse(column.find('input[id$="_dataDisplay"]').attr('value'))) !== null && _b !== void 0 ? _b : [];
                            formInput.appendChild(appn.elementBuilder.getSelectListFor(type, values, display, ['formatType', 'form-control form-control-sm'], inputName, inputId, undefined, required));
                            break;
                        }
                        case appn.elementBuilder.HTMLElementType.Decimal:
                        case appn.elementBuilder.HTMLElementType.Integer:
                        case appn.elementBuilder.HTMLElementType.Long:
                        case appn.elementBuilder.HTMLElementType.Boolean:
                        case appn.elementBuilder.HTMLElementType.Hidden:
                        case appn.elementBuilder.HTMLElementType.Rest:
                        case appn.elementBuilder.HTMLElementType.Text: {
                            const numLines = column.data('numlines');
                            if (numLines)
                                formInput.appendChild(appn.elementBuilder.createElement('textarea', 'form-control form-control-sm', inputId, [['name', inputName], ['placeholder', T('Enter text...')], ['rows', '1'], ['cols', '20'], ['required', required ? 'required' : '']]));
                            else {
                                let placeholderType = appn.emptyString;
                                let inputType = appn.elementBuilder.HTMLInputType.Text;
                                switch (type) {
                                    case appn.elementBuilder.HTMLElementType.Decimal: {
                                        placeholderType = T('number (with decimals)');
                                        break;
                                    }
                                    case appn.elementBuilder.HTMLElementType.Integer:
                                    case appn.elementBuilder.HTMLElementType.Long: {
                                        placeholderType = T('number (no decimals)');
                                        break;
                                    }
                                    case appn.elementBuilder.HTMLElementType.Boolean: {
                                        inputType = appn.elementBuilder.HTMLInputType.CheckBox;
                                        break;
                                    }
                                    default: {
                                        placeholderType = T('text');
                                        break;
                                    }
                                }
                                formInput.appendChild(appn.elementBuilder.getSimpleInputFor('form-control form-control-sm', inputName, inputId, inputType, placeholderType.length > 0 ? T('Enter {0}...', placeholderType) : undefined, undefined, required));
                            }
                            break;
                        }
                    }
                    formInput.appendChild(appn.elementBuilder.createElement('span', ['field-validation-valid', 'help-block', 'small'], undefined, [['data-valmsg-for', inputName], ['data-valmsg-replace', 'true']]));
                    const formGroup = appn.elementBuilder.createElement('div', ['form-group', 'row']);
                    formGroup.appendChild(formInput);
                    cell.appendChild(formGroup);
                    return cell;
                }
                function getIdString(name) {
                    return name.split('[').join('_').split(']').join('_').split('.').join('_');
                }
            })(wizard3 = taskTemplates.wizard3 || (taskTemplates.wizard3 = {}));
        })(taskTemplates = views.taskTemplates || (views.taskTemplates = {}));
    })(views = appn.views || (appn.views = {}));
})(appn || (appn = {}));
